var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroidIconImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18.887,
    viewBox: "0 0 16 18.887",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "android-os",
    transform: "translate(-8 -5.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60205",
    "data-name": "Path 60205",
    d: "M10,23.5a1,1,0,1,1-2,0V19a1,1,0,0,1,2,0Z",
    transform: "translate(0 -5.5)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60206",
    "data-name": "Path 60206",
    d: "M38,23.5a1,1,0,1,1-2,0V19a1,1,0,0,1,2,0Z",
    transform: "translate(-14 -5.5)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60207",
    "data-name": "Path 60207",
    d: "M20,34.5a1,1,0,0,1-2,0V30a1,1,0,0,1,2,0Z",
    transform: "translate(-5 -11)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60208",
    "data-name": "Path 60208",
    d: "M28,34.5a1,1,0,0,1-2,0V30a1,1,0,0,1,2,0Z",
    transform: "translate(-9 -11)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60209",
    "data-name": "Path 60209",
    d: "M14,18v7.5a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V18Z",
    transform: "translate(-3 -5.5)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60210",
    "data-name": "Path 60210",
    d: "M19,8c-3,0-4.827,1.823-5,4H24C23.827,9.823,22,8,19,8Zm-2,2.8a.5.5,0,1,1,.5-.5A.5.5,0,0,1,17,10.8Zm4,0a.5.5,0,1,1,.5-.5A.5.5,0,0,1,21,10.8Z",
    transform: "translate(-3 -0.5)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60211",
    "data-name": "Path 60211",
    d: "M29.167,7l-.833,1.25",
    transform: "translate(-10.167)",
    fill: "none",
    stroke: "#7cb342",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60212",
    "data-name": "Path 60212",
    d: "M18,7l.667,1.041",
    transform: "translate(-5)",
    fill: "none",
    stroke: "#7cb342",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIconImage);
export default __webpack_public_path__ + "static/media/android_icon_image.fb898d13468dfb110e550109af77e38f.svg";
export { ForwardRef as ReactComponent };